// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".molecule-content-blocks .inner[data-v-b34023ba]{flex:1}.molecule-content-blocks .inner .title-box[data-v-b34023ba]{background:#000;border-radius:.125rem;color:#fff;display:inline-block;font-size:1.25rem;gap:4px;margin-bottom:1rem;margin-right:.625rem;padding:.313rem .5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
